// extracted by mini-css-extract-plugin
export default {"item-list":"MainsMobile_item-list__0LnES","item":"MainsMobile_item__NOPj8","main-section":"MainsMobile_main-section__ywEfQ","mains-subtitle":"MainsMobile_mains-subtitle__EUC4i"};